var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { connect } from 'react-redux';
import GestorSesiones from '../componentes/gestor-sesiones';
import * as actions from '../actions';
import * as selectors from '../selectors';
import { getConfigGeneral } from '../../selectors';
var GestorSesionesContainer = connect(function (state, ownProps) {
  var configGeneral = getConfigGeneral(state);
  var configGestorSesiones = configGeneral.gestorSesiones || {};
  var idUltimaSesionActiva = selectors.getIdUltimaSesionActiva(state);
  var idSesionActiva = selectors.getIdSesionActiva(state);
  var sesiones = selectors.getSesiones(state) || [];
  return _extends({
    visible: idSesionActiva === null,
    idUltimaSesionActiva: idUltimaSesionActiva,
    sesiones: sesiones
  }, configGestorSesiones);
}, function (dispatch, ownProps) {
  return {
    onNuevaSesion: function onNuevaSesion(nombre) {
      return dispatch(actions.crearSesion(nombre));
    },
    onEntrar: function onEntrar(sesion) {
      return dispatch(actions.activarSesion(sesion.id));
    },
    onImportarSesion: function onImportarSesion(sesion) {
      return dispatch(actions.importarSesion(sesion));
    },
    onExportarSesion: function onExportarSesion(sesion) {
      return dispatch(actions.exportarSesion(sesion));
    },
    onEliminarSesion: function onEliminarSesion(sesion) {
      return dispatch(actions.eliminarSesion(sesion.id));
    }
  };
})(GestorSesiones);
export default GestorSesionesContainer;